import PrisonService from '@/services/PrisonService';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    prison: null,
  },
  getters: {
    prisonPermissions(state) {
      return {
        allow_social_visits: state.prison?.allow_social_visits || false,
        allow_in_cell_calls: state.prison?.allow_in_cell_calls || false,
        // Add other permissions as needed
      };
    },
  },
  mutations: {
    SET_PRISON(state, prison) {
      state.prison = prison;
    },
  },
  actions: {
    // eslint-disable-next-line
    async getPrison({commit, state, rootState, rootGetters}, refresh = false) {
      const { prison } = state;
      if (prison && !refresh) { // return if already set
        return prison;
      }
      await PrisonService.getPrison().then(res => {
        commit('SET_PRISON', res.data);

        // Update global permissions
        const permissions = {
          ...rootState.permissions,
          ...rootGetters['prison/prisonPermissions'],
        };
        commit('SET_PERMISSIONS', permissions, { root: true });

        return res.data;
      }).catch(e => {
        Vue.$toast.error('Could not get prison, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
        throw e;
      });

      return null;
    },
  },
};
